import * as React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export interface QueryLoadingScreenProps {
	/** Loading message to display */
	message?: string;
	/** Show progress indicator */
	showProgress?: boolean;
}

export function QueryLoadingScreen({
	message = "Executing query...",
	showProgress = true,
}: QueryLoadingScreenProps): React.JSX.Element {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				minHeight: "200px",
				py: 3,
			}}>
			<Stack
				spacing={3}
				alignItems="center">
				{showProgress && (
					<CircularProgress
						size={40}
						thickness={4}
						sx={{ color: "var(--mui-palette-primary-main)" }}
					/>
				)}
				<Stack
					spacing={1}
					alignItems="center">
					<Typography
						variant="body1"
						sx={{ fontWeight: "medium" }}>
						{message}
					</Typography>
					<Typography
						variant="body2"
						color="text.secondary"
						sx={{ textAlign: "center" }}>
						Please wait while we process your request
					</Typography>
				</Stack>
			</Stack>
		</Box>
	);
}
